/* SOAR Reveal — Intersection Observer for scroll-triggered animations */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.soar-reveal').forEach(function (el) {
      el.classList.add('revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function observe() {
    document.querySelectorAll('.soar-reveal:not(.revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Re-observe when Shopify section rendering adds new elements */
  document.addEventListener('shopify:section:load', observe);
})();
